// extracted by mini-css-extract-plugin
module.exports = {"buttonBack":"button-back_buttonBack__2McOp"};